import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material';

export default function EntryIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = useTheme().palette.primary.dark;
  const color = props.htmlColor || defaultColor;
  return (
    <SvgIcon
      {...props}
      htmlColor={color}
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 34 34"
      xmlSpace="preserve"
      enableBackground="new 0 0 34 34"
      titleAccess="Entry">
      <g filter="url(#filter0_d_6259_22782)">
        <ellipse cx={16.9999} cy={13.0004} rx={12.2143} ry={12.2143} fill="#0A4842" />
      </g>
      <ellipse cx={16.9998} cy={13.0003} rx={8.14286} ry={8.14286} fill="#fff" />
      <defs>
        <filter
          id="filter0_d_6259_22782"
          x={0.785645}
          y={0.786133}
          width={32.4287}
          height={32.4287}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_6259_22782" />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_6259_22782"
            result="shape"
          />
        </filter>
      </defs>
    </SvgIcon>
  );
}
